/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { getTranslation } from '@/store/getters'
import { toggleToaster, editMagazine } from '@/store/actions'

import styles from './styles.scss'

/** Components */
import Modal from '@/components/Modal'
import Button from '@/components/Button'
import UploadImage from '@/components/UploadImage'

class MagazineEdit extends Component {
  state = {
    thumbnail: ''
  }

  componentWillMount () {
    const { magazine } = this.props
    
    if( !magazine ) {
      return this.props.history.push( '/dashboard' )
    }

    this.setState( {
      thumbnail: magazine.thumbnail
    } )
  }

  handleEditThumbnail = () => {
    const { translation, magazine, editMagazine, toggleToaster, handleClose } = this.props

    editMagazine( magazine.id, this.state )
    handleClose()
    toggleToaster( {
      isVisible: true,
      message: translation( 'general-magazine-edit-success' ),
      position: 'top-right',
      type: 'success'
    } )
  }

  render () {
    const { thumbnail } = this.state
    const { show, translation, magazine, handleClose } = this.props

    return (
      <Modal
        show={show}
        style={ { zIndex: 50 } }
        handleClose={handleClose}
        handleAccept={this.handleEditThumbnail}
      >
        <div className={styles['wrapper-magazine-thumbnail']} >
          <h1>{translation( 'general-edit-information' )}</h1>

          <div className={styles['wrapper-magazine-thumbnail-content']}>
            <label htmlFor={`title-${magazine.id}`}>
              Thumbnail
            </label>
            <div>
              {!!thumbnail &&
                <img src={thumbnail} alt="Thumbnail" width={220} height={315} />
              }
              
            </div>
            <UploadImage
              onImageSended={thumbnail => this.setState( { thumbnail } )}
            />
          </div>
          <div className={styles['wrapper-magazine-thumbnail-buttons']}>
            <Button
              color="light"
              size="small"
              onClick={handleClose}
            >
              { translation( 'general-cancel' ) }
            </Button>
            <Button
              color="success"
              size="small"
              data-ba-i="magazine-edit-magazine"
              onClick={this.handleEditThumbnail}
            >
              { translation( 'general-save' ) }
            </Button>
          </div>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = state => {
  const translation = getTranslation( state )
  return { translation }
}
export default withRouter( connect(
  mapStateToProps, {
    toggleToaster,
    editMagazine
  }
)( MagazineEdit ) )



// WEBPACK FOOTER //
// ./src/pages/Dashboard/components/MagazineThumbnail/index.js